// extracted by mini-css-extract-plugin
export default {"light":"DarkMode_light__vaCCZ","dark":"DarkMode_dark__TrGvS"};